import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Application } from '../../clients/aasServerClient.generated';
import { getAssignablePrivileges } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import FormInput from '../common/FormInput';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { getServerAliases, getMaintenanceMode, setMaintenanceMode } from '../../repositories/ApplicationRepository';

interface Props extends LocalizeContextProps {
    type: 'edit' | 'new';
    application: Partial<Application>;
    updateApplication: (application: Partial<Application>) => void;
}

class ApplicationProperties extends React.Component<Props, Partial<Application>> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            ...props.application,
            serverAliasOptions: [],
            loadingAliases: false,
            aliasFetchError: false,
            aliasesFetched: false,
            server_alias: props.application.server_alias || '',
        } as any;
        this.props.updateApplication(this.state);
    }

    private fetchAliases = async () => {
        if ((this.state as any).aliasesFetched) return;
        this.setState({ loadingAliases: true, aliasFetchError: false } as any);
        try {
            const aliases = await getServerAliases();
            this.setState({
                serverAliasOptions: aliases.map(a => ({ label: a, value: a })),
                loadingAliases: false,
                aliasFetchError: false,
                aliasesFetched: true,
            } as any);
        } catch (e) {
            this.setState({
                loadingAliases: false,
                aliasFetchError: true,
                aliasesFetched: true,
            } as any);
        }   
    };

    public render() {
        const t = this.props.translate;
        this.updateMainenanceMode();
        return (
            <React.Fragment>
                <FormInput
                    row={true}
                    name="title"
                    fullName={t('applications.edit.field.title') as string}
                    value={this.state.title || ''}
                    onChange={this.handleApplicationChange}
                />
                <FormInput
                    row={true}
                    name="location_path"
                    fullName={t('applications.edit.field.location') as string}
                    value={this.state.location_path || ''}
                    onChange={this.handleApplicationChange}
                />
                <FormInput
                    row={true}
                    name="help_url"
                    fullName={t('applications.edit.field.helpUrl') as string}
                    value={this.state.help_url || ''}
                    onChange={this.handleApplicationChange}
                />
                <FormInput
                    row={true}
                    name="color"
                    fullName={t('applications.edit.field.color') as string}
                    value={this.state.color || ''}
                    onChange={this.handleApplicationChange}
                />
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                <label
                    style={{
                        minWidth: 123,
                        marginRight: 16,
                        marginTop: (this.state as any).aliasFetchError ? 35 : 10,
                        color: '#777777'
                    }}
                >
                    {t('applications.edit.field.server_alias') as string}
                </label>
            <div style={{ flex: 1 }}>
                {(this.state as any).aliasFetchError && (
                    <div style={{ color: 'red', marginBottom: 8 }}>
                        {t('applications.edit.field.server_alias_error') as string}
                    </div>
                )}
                <CreatableSelect
                    className="dropdown-select server-alias-select"
                    value={
                        this.state.server_alias
                            ? { label: this.state.server_alias, value: this.state.server_alias }
                            : null
                    }
                    options={(this.state as any).serverAliasOptions}
                    isLoading={(this.state as any).loadingAliases}
                    onMenuOpen={this.fetchAliases}
                    onChange={opt => {
                        const value = opt ? (opt as any).value : '';
                        this.setState({ server_alias: value }, () => {
                            this.props.updateApplication({ ...this.state, server_alias: value });
                        });
                    }}
                    isClearable
                    placeholder="Select server alias..."
                    formatCreateLabel={inputValue => `Use "${inputValue}"`}
                />
                </div>
                </div>
                <FormInput
                    row={true}
                    name="no_login_as"
                    type="checkbox"
                    fullName={t('applications.edit.field.no_login_as') as string}
                    checked={this.state.no_login_as}
                    checkboxProp={true}
                    onChange={this.handleApplicationChange}
                />              
                <FormInput
                    row={true}
                    name="maintenanceMode"
                    type="checkbox"
                    fullName='Maintenance Mode'// {t('applications.edit.field.') as string}
                    checked={this.state.maintenanceMode}
                    checkboxProp={true}
                    disabled={this.state.maintenanceMode === undefined}
                    onChange={this.handleMaintenanceModeChange.bind(this)}
                />
            </React.Fragment>
        );
    }

    private async updateMainenanceMode() {
        if (this.props.application.id) {
            try {
                var mode = await getMaintenanceMode(this.props.application.id);
                if (this.state.maintenanceMode !== mode) {
                    this.setState({ maintenanceMode: mode });
                }
            } catch { }
        }
    }
    
    private async handleMaintenanceModeChange(e: React.ChangeEvent<HTMLInputElement>) {
        var val = e.target.checked ?? false;
        this.setState({ maintenanceMode: val });
        val = await setMaintenanceMode(this.state.id!, val);
        const update = { maintenanceMode: val };
        this.setState(update);
        this.props.updateApplication({ ...this.state, ...update });
    }

    private handleApplicationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const update = {
            [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
        };
        this.setState(update);
        this.props.updateApplication({ ...this.state, ...update });
    }
}

const mapStateToProps = (state: RootState) => ({
});

export default connect(mapStateToProps)(withLocalize(ApplicationProperties));